import moment from 'moment';
import { ISODate } from './types';

export default (date: ISODate, s: moment.unitOfTime.StartOf) =>
  moment(date).startOf(s).toISOString();
